export default "__VITE_ASSET__BsBihp1O__"